import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  constructor() {}
  readonly CULTURE_TAG: string = 'culture';

  public doesCultureExist(): boolean {
    return this.getCulture() != null;
  }

  public getCulture(): string {
    return localStorage.getItem(this.CULTURE_TAG);
  }

  public setCulture(value) {
    localStorage.setItem(this.CULTURE_TAG, value);
  }
}
